export function formatEventDate(dateStr: string): string {
  const [datePart, timePart] = dateStr.split(/[ T]/)
  if (!datePart) return dateStr
  const [year, month, day] = datePart.split('-')
  const time = timePart ? timePart.slice(0, 5) : ''
  return time ? `${day}/${month}/${year} ${time}` : `${day}/${month}/${year}`
}

export function formatDeliveryDate(dateStr: string): string {
  // Patrus format: "25T00:00:00/05/2026" → day/month/year
  if (dateStr.includes('/')) {
    const parts = dateStr.split('/')
    const day = parts[0].split('T')[0]
    const month = parts[1]
    const year = parts[2]
    return `${day}/${month}/${year}`
  }
  // Standard ISO format: "YYYY-MM-DD" or "YYYY-MM-DDThh:mm:ss"
  const datePart = dateStr.split('T')[0]
  const [year, month, day] = datePart.split('-')
  return `${day}/${month}/${year}`
}
